import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectPortalUser } from '../reducers/auth-slice';
import BeatLoader from 'react-spinners/BeatLoader';
import AppRouter from '../app-router';
import { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { b2cPolicies, protectedResources, loginRequest } from '../authConfig';
import AuthService from '../services/auth-service';
import { setADUser, selectAdUser, fetchAuth, selectActiveFeatures } from '../reducers/auth-slice';

const Portal = () => {
    const [allowNewOrders, setAllowNewOrders] = useState(false);
    const [canSeeOrders, setCanSeeOrders] = useState(true);
    const navigate = useNavigate();
    const portalUser = useSelector(selectPortalUser);
    var renderHelpMessage = portalUser.organization ? portalUser.organization.status != "Enabled" : false;

    useEffect(() => {
        setAllowNewOrders(portalUser && (portalUser.userType == 'glucroft' || (portalUser.organization && portalUser.organization.status == 'Enabled')));
        setCanSeeOrders(portalUser && portalUser.organization && (portalUser.organization.status == 'Disabled' || portalUser.organization.status == "Inactive"));
    }, [portalUser]);
    
    /**
     * handle the add new
     */
    const handleAddNew = () => {
        navigate("/intake/general-information");
    };

    const navigateHome = () => {
        navigate('/orders');
    }

    const renderGlucroftUserMsg = () => {
        return (
            <div className="left">
                <h2>WELCOME, {portalUser.firstName}</h2>
            </div>            
        )
    }

    const renderPortalUserMsg = () => {
        return (
            <div className="left">
                <h2>WELCOME, {portalUser.firstName}</h2>
            </div>            
        )
    }

    const { instance } = useMsal();
    const handleLogoutLoginRedirect = (e) => {
        console.log("logging out...");
        e.preventDefault();
        let activeAccount = instance.getActiveAccount();
        if (activeAccount) {
            instance.logout(activeAccount);
        }
    }

    const renderDisabledUserMsg = () => {
        const msg = (portalUser.organization && portalUser.organization.status == "Inactive") ? `${portalUser.organization.firm} is inactive.  Please contact Glucroft Investigations at 866-411-8646 to reactivate your account.` : 
            "Please contact Glucroft Investigations Office at 866-411-8646 regarding your account. Thank you."
        return (
                <div className="left">
                <h3>{msg}</h3>
                <button className="button tertiary" onClick={canSeeOrders ? navigateHome : handleLogoutLoginRedirect}>OK</button>
            </div>                  
        )
    }

    return (
        <div className="page portal">
            {(portalUser.status === 'loading' || portalUser.status === 'idle') &&
                <div className="loader-container">
                    <BeatLoader color="#00818C" />
                </div>
            }
            {portalUser.status === 'rejected' || (portalUser.status != 'rejected' && renderHelpMessage) ? renderDisabledUserMsg() : (portalUser.userType === "glucroft" ? renderGlucroftUserMsg() : renderPortalUserMsg())}
            {(portalUser.status != 'rejected') && allowNewOrders &&
                <div className="right">
                    <button className="button secondary" type="button" onClick={handleAddNew}>+ Add New Order</button>
                </div>
            }
        </div>
    );
};

export default Portal;